// ============================================================
// ChatContext (v8.363.3) - the vox, for the log panel and the header.
// Composed in DeathWatchSimulator from useChat + useChannels + useUnread.
// ============================================================
import { createContext, useContext } from 'react';

const ChatContext = createContext(null);

export function ChatProvider({ value, children }) {
  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
}

/** Null outside a session or before the provider mounts. */
export function useChatContext() {
  return useContext(ChatContext);
}
